import React from 'react';

export default () => (
  <svg
    focusable='false'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
    width='24'
    height='24'
    viewBox='0 0 24 24'
  >
    <path d='M10.177 1.874a8.303 8.303 0 0 1 6.378 13.618l5.35 5.352a.75.75 0 0 1-1.06 1.06l-5.35-5.351a8.303 8.303 0 1 1-5.318-14.679zm0 1.5a6.802 6.802 0 1 0 0 13.605 6.802 6.802 0 0 0 0-13.605zm3.698 6a.75.75 0 1 1 0 1.5h-7.5a.75.75 0 0 1 0-1.5z' />
  </svg>
);
